import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { FilterGroupModel } from '../../../../../../../Common/Filter/models/filter-group.model';
import { FilterService } from '../../../../../../../Common/Filter/services/abstract-filter.service';
import { RecipientResultModel } from '../../../../../models/recipient.result.model';
import { AdditionalRecipientSearchService } from '../additional-recipient-search.service';

@Component({
    selector: 'agpr-additional-recipient-toolbar',
    templateUrl: './additional-recipient-toolbar.component.html',
    styleUrls: ['./additional-recipient-toolbar.component.scss'],
    providers: [
        {
            provide: 'PaginatorServiceInterface',
            useExisting: AdditionalRecipientSearchService
        },
        {
            provide: FilterService,
            useExisting: AdditionalRecipientSearchService
        },
        {
            provide: 'SortOrderServiceInterface',
            useExisting: AdditionalRecipientSearchService
        }
    ],
    standalone: false
})
export class AdditionalRecipientToolbarComponent implements OnDestroy {

    results: RecipientResultModel[];
    totalResults: number;
    loading = false;
    chipsVisible = false;

    private subscriptions: Subscription[] = [];

    constructor(public additionalRecipientSearchService: AdditionalRecipientSearchService) {
        this.subscriptions.push(
            this.additionalRecipientSearchService.getDisplayResults().subscribe(results => {
                this.results = results;
            }),
            this.additionalRecipientSearchService.getItemCount().subscribe(total => this.totalResults = total),
            this.additionalRecipientSearchService.getFilters().subscribe(filters => {
                this.chipsVisible = !!filters.find(filter => {
                    if (filter instanceof FilterGroupModel) {
                        return filter.children.find(x => x.chips && x.chips.length > 0);
                    } else {
                        return filter.chips && filter.chips.length > 0;
                    }
                });
            }),
            this.additionalRecipientSearchService.getPageCriteria().subscribe(pageCriteria => null),
            this.additionalRecipientSearchService.getSearchLoading().subscribe(loading => this.loading = loading),
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(
            subscription => subscription.unsubscribe()
        );
    }
}
